<template>
  <div class="global-navi-menu-list">

    <side-menu-profile v-if="viewerId" :active="active" @loaded="$emit('content-changed')" />
    <side-menu-login v-if="!viewerId && loginUrl" :login-url="loginUrl" />

    <component
      v-for="menuGroup in menuGroups"
      :is="menuGroup"
      :ref="menuGroup.name"
      :key="menuGroup.name"
      :active="active"
      @content-changed="$emit('content-changed')"
    />

    <side-menu-footer />
  </div>
</template>

<script>
import SideMenuLogin                from './side-menu-login';
import SideMenuProfile              from './side-menu-profile';
import SideMenuGroupAtcosme         from './side-menu-group/atcosme';
import SideMenuGroupCustomerSupport from './side-menu-group/customer-support';
import SideMenuGroupAnnouncement    from './side-menu-group/announcement';
import SideMenuGroupCompanyInfo     from './side-menu-group/company-info';
import SideMenuFooter               from './side-menu-footer';

export default {
  name      : 'side-menu',
  components: {
    SideMenuLogin,
    SideMenuProfile,
    SideMenuFooter,
  },
  props: {
    loginUrl: {
      type   : String,
      default: '',
    },
    active: {
      type   : Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      menuGroups: [
        SideMenuGroupAtcosme,
        SideMenuGroupAnnouncement,
        SideMenuGroupCustomerSupport,
        SideMenuGroupCompanyInfo,
      ],
    };
  },
  computed: {
    viewerId: function() {
      return this.$store.state.context.viewer.istyleId;
    },
  },
  methods: {
    findMenuGroup: function(name) {
      if (!name) {
        return;
      }
      const group = this.$refs['side-menu-group-' + name];
      if (group) {
        // Vueの仕様でv-forでループしているので配列になっている
        return group[0];
      }
    },
    // 固有メニューを指定した名前のmenuGroupの後に追加
    insertMenuGroupAfter: function(name, ...customGroups) {
      let menuGroupIndex = -1;
      this.menuGroups.forEach((group, index) => {
        if (group.name === 'side-menu-group-' + name) {
          menuGroupIndex = index;
        }
      });

      // 指定した名前が見つからなければ終了
      if (menuGroupIndex < 0) {
        return;
      }

      // 固有メニューを指定した箇所への追加
      this.menuGroups.splice(menuGroupIndex + 1, 0, ...customGroups);
    },
  },
};
</script>
